import keys from '@debbie/common/dist/cache/keys.js';
import { FoundationCode, } from '@debbie/common/dist/customers/index.js';
import { getFoundations, isDocumentFoundation, } from '@debbie/common/dist/documents/index.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { parseOrStr } from '@debbie/common/dist/util/index.js';
import { casesEntity, ensureCaseLoaded, } from '@debbie/cortex/dist/cases/index.js';
import { customersEntity, ensureCustomerLoaded, } from '@debbie/cortex/dist/customers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../utils/errors.js';
import Alert from '../Alert.js';
import { CheckCircle, Shield } from '../Icons/index.js';
import { Badge, Button, Checkbox, DateInput, File as FileComponent, Input, Modal, Select, } from '../index.js';
import { getDescriptor } from './registries.js';
const MoveToOpenModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [amount, setAmount] = useState(null);
    const [foundationCode, setFoundationCode] = useState(null);
    const [foundationDate, setFoundationDate] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const tenant = useTenant();
    const manglerAdvokatindestaaelse = tenant?.settings?.manglerAdvokatindestaaelse === true;
    const documentsLoadable = useDocumentsByReference(props.case.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const foundationFiles = documents
        ? getFoundations(documents).filter((d) => d.file)
        : [];
    const moveToOpenMutation = useMutation(async () => {
        if (!manglerAdvokatindestaaelse && (!foundationCode || !foundationDate)) {
            throw new Error('Mangler oplysninger om fundamentet');
        }
        if (!props.userId) {
            throw new Error('Ingen debitor valgt.');
        }
        if (!props.rkiReferenceId) {
            throw new Error('Intet rkiReferenceId valgt.');
        }
        const moveToOpenAction = getDescriptor(props.registry).actions.moveToOpen;
        if (!moveToOpenAction) {
            throw new Error('Tilføj fundament understøttes ikke af dette register.');
        }
        await moveToOpenAction.call(props.userId, props.case.caseId, props.rkiReferenceId, {
            claim: foundationCode && foundationDate
                ? {
                    amount: Math.round((amount || 0) * 100),
                    foundationCode: foundationCode,
                    foundationDate: foundationDate.format(),
                }
                : undefined,
            files: manglerAdvokatindestaaelse
                ? selectedFiles.map((f) => f.fileId)
                : undefined,
        });
        q.invalidate(keys.write.modify(casesEntity, props.case.caseId));
        q.invalidate(keys.write.modify(customersEntity, props.customer.customerId));
        await ensureCaseLoaded(props.case.caseId);
        await ensureCustomerLoaded(props.customer.customerId);
        props.toggleMoveToOpenModal();
    }, {
        onError: (error) => {
            const err = 'message' in error ? parseOrStr(error.message) : error;
            errorNotification(lang, err, 'update', lang.errorEntities.rkiRegistration, typeof err === 'object' && 'description' in err
                ? err.description
                : String(err));
        },
    });
    useEffect(() => {
        if (!Number.isNaN(amount)) {
            return;
        }
        if (!props.caseVouchers) {
            setAmount(0);
            return;
        }
        const balance = -helpers.overview.balance(props.caseVouchers);
        setAmount(balance / 100);
    }, [props.caseVouchers]);
    useEffect(() => {
        if (documents && !foundationDate) {
            const foundations = getFoundations(documents);
            if (foundations.length > 0) {
                setFoundationDate(moment(foundations[0].signedAt || foundations[0].date));
            }
        }
    }, [documents]);
    // The copy below is RKI-specific; moveToOpen is currently only enabled for
    // RKI. If another registry enables this action, move the texts into the
    // registry descriptor.
    return (React.createElement(Modal, { header: "Tilf\u00F8j fundament til RKI-registrering", onToggle: props.toggleMoveToOpenModal, maxWidth: "410px" },
        !manglerAdvokatindestaaelse && (React.createElement(React.Fragment, null,
            React.createElement(Input, { placeholder: "Bel\u00F8b", type: "number", value: amount || '', onChange: (e) => setAmount(e.target.value) }),
            React.createElement(Select, { value: foundationCode, onChange: (e) => setFoundationCode(e.target.value) },
                React.createElement("option", { value: "" },
                    "- ",
                    lang.debtRegistration.chooseFoundationType,
                    " -"),
                Object.values(FoundationCode).map((e) => (React.createElement("option", { key: e, value: e }, lang.debtRegistration.foundationCode[e])))),
            React.createElement(DateInput, { allowNull: true, placeholder: lang.debtRegistration.dateFoundation, onChange: (d) => setFoundationDate(d), value: foundationDate || undefined, maxDate: moment().toDate() }))),
        manglerAdvokatindestaaelse &&
            documents &&
            (foundationFiles.length > 0 ? (React.createElement(FoundationFilePicker, null, foundationFiles.map((doc) => {
                const file = doc.signedFile || doc.file;
                const isChecked = selectedFiles.some((f) => f.fileId === file.fileId);
                return (React.createElement(FoundationFileRow, { key: doc.documentId },
                    React.createElement(Checkbox, { checkMark: true, checkboxStyle: { margin: '0' }, style: { margin: '0' }, checked: isChecked, onChange: (e) => {
                            setSelectedFiles(e.target.checked
                                ? [...selectedFiles, file]
                                : selectedFiles.filter((f) => f.fileId !== file.fileId));
                        } }),
                    React.createElement(FileComponent, { file: file, style: { marginBottom: '0px', maxWidth: '50%' }, noWrap: true }),
                    React.createElement(Badge, { style: { marginBottom: '0px' }, theme: "lightgrey" }, lang.documentTypes[doc.type] || doc.type),
                    isDocumentFoundation(doc) && (React.createElement(Shield, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.isFoundation, style: { color: '#3b92d3', flexShrink: 0 } })),
                    doc.signedAt && (React.createElement(CheckCircle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.documentSigned, style: { color: '#3b92d3', flexShrink: 0 } }))));
            }))) : (React.createElement(Alert, { size: "small", message: lang.debtRegistration.noFoundationsOnCase }))),
        React.createElement(Button, { disabled: !(manglerAdvokatindestaaelse
                ? selectedFiles.length > 0
                : foundationCode &&
                    foundationDate &&
                    Math.round((amount || 0) * 100)), loading: moveToOpenMutation.isLoading, block: true, onClick: () => moveToOpenMutation.mutate() }, "Tilf\u00F8j fundament til RKI-registrering")));
};
export default MoveToOpenModal;
const FoundationFilePicker = styled.div `
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`;
const FoundationFileRow = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
//# sourceMappingURL=MoveToOpenModal.js.map